export default function Legal() {
  return (
    <section data-testid="legal-page" className="mx-auto max-w-3xl px-6 py-16 lg:py-24">
      <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--clinic-muted))]">Legal</div>
      <h1 className="mt-2 font-display text-4xl sm:text-5xl">Aviso legal, privacidad y cookies</h1>
      <p className="mt-4 text-sm text-[hsl(var(--clinic-muted))]">
        Última actualización: 2026. Al usar este sitio aceptas las condiciones descritas a continuación.
      </p>
      <Section title="1. Titular del sitio">
        Katia Falón Odontología · Cra. 14 #17N-32, Armenia, Quindío, Colombia. Contacto: info@katiafalonodontologia.com — (+57) 311 300 9975.
      </Section>
      <Section title="2. Datos personales (Ley 1581 de 2012)">
        Los datos que nos entregues al reservar cita o al contactarnos se tratan con la finalidad exclusiva de
        prestar el servicio odontológico solicitado, comunicaciones asistenciales y cumplimiento normativo.
        No se ceden a terceros salvo obligación legal.
      </Section>
      <Section title="3. Derechos del paciente">
        Puedes ejercer los derechos de acceso, actualización, rectificación y supresión escribiendo a info@katiafalonodontologia.com.
      </Section>
      <Section title="4. Cookies">
        Utilizamos cookies técnicas necesarias para el funcionamiento del sitio y, opcionalmente, cookies analíticas
        (Google Analytics 4). Puedes rechazarlas desde la configuración de tu navegador. Detalles específicos por
        cookie se publicarán una vez validado el análisis técnico.
      </Section>
      <Section title="5. Consentimiento informado">
        Todo tratamiento odontológico se realiza previa firma de consentimiento informado escrito, entregado
        físicamente en consultorio antes de iniciar cualquier intervención.
      </Section>
      <Section title="6. Cambios en este aviso">
        Este documento puede actualizarse. La versión vigente será siempre la publicada en esta página.
      </Section>
    </section>
  );
}

function Section({ title, children }) {
  return (
    <div className="mt-10">
      <h2 className="font-display text-2xl">{title}</h2>
      <p className="mt-3 text-sm leading-relaxed text-[hsl(var(--clinic-muted))]">{children}</p>
    </div>
  );
}
